<script>
export default {
  render(h) {
    return h();
  },
};
</script>
